<template>
  <div class="park-display-screen">
    <div class="portrait-of-enterprises-bg-img-out-box">
      <div class="portrait-of-enterprises-bg-img-box">
        <!--<img :src="parkDisplayScreenBottomBasicBigMap" class="portrait-of-enterprises-bg-img" alt="">-->
        <img src="../../../assets/park_bg/jxgj.jpg" class="portrait-of-enterprises-bg-img" alt="" v-if="yqCode === 'jxgj'">
        <!--<scene-model />-->
      </div>
    </div>

    <div class="park-display-screen-svg-box">

      <!--左 -->
      <div class="portrait-of-enterprises-left">
        <!--<div class="portrait-of-enterprises-left-nav">-->
        <!--<div :class="currentNav === nav.code ? 'portrait-of-enterprises-left-nav-item2' : 'portrait-of-enterprises-left-nav-item'" v-for="nav in leftNavList" @click="changeNav(nav)" >-->
        <!--<div class="portrait-of-enterprises-left-nav-item-title-box">-->
        <!--<div class="portrait-of-enterprises-left-nav-item-title">{{nav.name}}</div>-->
        <!--</div>-->
        <!--<div class="portrait-of-enterprises-left-nav-item-main">-->
        <!--<div class="portrait-of-enterprises-left-nav-item-main-item" v-for="navChild in nav.child">-->
        <!--<div>{{navChild.value}} {{navChild.unit}}</div>-->
        <!--<div style="color: #67E0E3">{{navChild.name}}</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!-- 设备监控 -->
        <transition name="el-zoom-in-center" >
          <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '5'">
            <div class="portrait-of-enterprises-item2">
              <div class="portrait-of-enterprises-item-title">
                <span class="portrait-of-enterprises-item-title-info">设备报警情况</span>
              </div>
              <div class="device-operation-alar-line">
                <div class="device-operation-alar-line-item">
                  <div class="device-operation-alar-line-item-info">{{ totalAlarmNumber }}</div>
                  <div class="device-operation-alar-line-item-name">今日报警数</div>
                </div>
                <div class="device-operation-alar-line-item">
                  <div class="device-operation-alar-line-item-info" style="color: #FB140F;">{{ unDealNumber }}</div>
                  <div class="device-operation-alar-line-item-name">未消警数</div>
                </div>
              </div>

              <dv-border-box-2 :color="['#F9C986', '#DC9533']" style="width: 100%;height: 2rem;margin-bottom: 0.1rem;">
                <div class="alarm-record-table">
                  <div class="alarm-record-table-head">
                    <div class="alarm-record-table-head-item" style="width: 30%;">报警设备</div>
                    <div class="alarm-record-table-head-item" style="width: 30%;">报警时间</div>
                    <div class="alarm-record-table-head-item" style="width: 20%;">状态</div>
                    <div class="alarm-record-table-head-item" style="width: 20%;">操作</div>
                  </div>
                  <div class="alarm-record-table-main">
                    <div class="alarm-record-table-main-line" v-for="alarmRecord in alarmRecordList">
                      <div class="alarm-record-table-head-item" style="width: 30%;">{{alarmRecord.deviceName}}</div>
                      <div class="alarm-record-table-head-item" style="width: 30%;">{{alarmRecord.alarmTime}}</div>
                      <div class="alarm-record-table-head-item" style="width: 20%;">{{alarmRecord.alarmStatus}}</div>
                      <div class="alarm-record-table-head-item" style="width: 20%;color: #F89812;cursor: pointer;">查看</div>
                    </div>
                    <div class="alarm-record-table-main-no-tip" v-if="alarmRecordList.length === 0">暂无报警信息</div>
                  </div>
                </div>
              </dv-border-box-2>

              <div class="portrait-of-enterprises-item-title">
                <span class="portrait-of-enterprises-item-title-info">当日值班表</span>
              </div>

              <div class="fireman-box">
                <div class="fireman-box-line" v-for="fireman in firemanList">
                  <i class="iconfont el-icon-damai-xiaofangyuan"></i>
                  <div class="fireman-box-line-name">{{fireman.personName}}</div>
                  <div class="fireman-box-line-phone"><i class="iconfont el-icon-damai-phone-channel" style="margin-right: 5px;"></i>{{fireman.personPhone}}</div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>


      <!-- 右 -->
      <div class="portrait-of-enterprises-right">
        <!-- 园区概况 -->
        <transition name="el-zoom-in-center" v-if="currentNav === '1'">
          <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '1'">
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <span class="portrait-of-enterprises-item-title-info">园区荣誉</span>
                </div>
                <div style="flex: 1;padding: 15px 25px;margin-top: 10px;overflow: hidden;" id="parkHonorTimer">
                  <el-timeline>
                    <el-timeline-item
                      v-for="(activity, index) in parkHonorData"
                      :key="index"
                      :icon="activity.icon"
                      :type="activity.type"
                      :color="activity.color"
                      :size="activity.size"
                      :timestamp="activity.timestamp">
                      {{activity.content}}
                    </el-timeline-item>
                  </el-timeline>
                </div>
              </div>
            </div>
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <span class="portrait-of-enterprises-item-title-info">园区活跃度</span>
                </div>
                <div style="flex: 1;display: flex;justify-content: space-between;align-items: center;">
                  <dv-decoration-9 style="width: 1.2rem;height: 1.2rem;" :dur="8" :color="['#66E1E3', '#339A9C']">
                    <span style="font-size: 24px;background-image:-webkit-linear-gradient(bottom, #0381B7, #71FCFD);-webkit-background-clip:text; -webkit-text-fill-color:transparent;">623</span>
                  </dv-decoration-9>
                  <dv-capsule-chart :config="parkActivityConfig" style="flex: 1;" />
                </div>
              </div>
            </div>
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <span class="portrait-of-enterprises-item-title-info">园区发展</span>
                </div>
                <div style="display: flex;justify-content: center;align-items: center;flex: 1;">
                  <dv-conical-column-chart :config="parkDevelopmentConfig" style="flex: 1;" />
                </div>
              </div>
            </div>
          </div>
        </transition>

        <!-- 企业风采 -->
        <transition name="el-zoom-in-center" v-if="currentNav === '2'">
          <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '2'">
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <span class="portrait-of-enterprises-item-title-info">企业培育</span>
                </div>
                <div style="flex: 1;display: flex;justify-content: space-between;align-items: center;">
                  <dv-active-ring-chart :config="enterpriseDistributionConfig" style="width: 120px;height: 120px;" />
                  <div style="flex: 1;margin-left: 20px;">
                    <div v-for="item in enterpriseDistributionInfoData" style="display: flex;justify-content: flex-start;align-items: center;margin: 5px 0;">
                      <i :class="item.icon" style="font-size: 28px;background-image:-webkit-linear-gradient(bottom, #37A2DA, #32C5E9, #67E0E3);-webkit-background-clip:text; -webkit-text-fill-color:transparent;"></i>
                      <div style="flex: 1;text-align: left;margin-left: 5px;">
                        <div style="font-size: 15px;"><span style="font-family: sans-serif;color: #eeeeee;">{{item.amount}}</span><span style="font-size: 12px;margin-left: 5px;">{{item.unit}}</span></div>
                        <div style="font-size: 12px;">{{item.name}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <span class="portrait-of-enterprises-item-title-info">知识产权</span>
                </div>
                <radar style="flex: 1;" radarId="enterpriseQualityRadarId" :titleStyle="commonTitleStyle" :radarColor="intellectualPropertyMultilineColor" :legendData="intellectualPropertyMultilineLegendData" :radarAxisData="intellectualPropertyMultilineAxis" :series="intellectualPropertyMultilineSeriesData" />
              </div>
            </div>
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <span class="portrait-of-enterprises-item-title-info">明星企业</span>
                </div>
                <div style="flex: 1;display: flex;justify-content: space-between;align-items: center;">
                  <dv-scroll-board :config="famousEnterpriseConfig" style="flex: 1;" />
                </div>
              </div>
            </div>
          </div>
        </transition>

        <!-- 人才信息 -->
        <transition name="el-zoom-in-center" v-if="currentNav === '3'">
          <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '3'">
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <span class="portrait-of-enterprises-item-title-info">人才分布</span>
                </div>
                <customized-pie style="flex: 1;" customizedPieItemsId="educationCustomizedPie" :series="educationMultilineSeriesData" />
                <!--<radar style="flex: 1;" radarId="enterpriseQualityRadarId" :titleStyle="commonTitleStyle" :radarColor="enterpriseQualityRadarColor" :legendData="enterpriseQualityRadarLegendData" :radarAxisData="enterpriseQualityRadarAxisData" :series="enterpriseQualityRadarSeriesData" />-->
              </div>
            </div>
          </div>
        </transition>

        <!-- 孵化成果 -->
        <transition name="el-zoom-in-center" v-if="currentNav === '4'">
          <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '4'">
            <div class="portrait-of-enterprises-item">
              <div style="height: 100%;padding: 10px 20px;display: flex;justify-content: flex-start;flex-direction: column;">
                <div class="portrait-of-enterprises-item-title">
                  <!--<i class="portrait-of-enterprises-item-title-icon el-icon-damai-company_quality"></i>-->
                  <span class="portrait-of-enterprises-item-title-info">园区年产值</span>
                </div>
                <div style="display: flex;justify-content: flex-start;align-items: center;flex: 1;">
                  <common-line-and-bar style="flex: 1;" commonLineAndBarId="energyConsumption" :commonLineAndBarColor="energyConsumptionColor" :legendData="energyConsumptionLegendData" :commonLineAndBarXAxis="energyConsumptionXAxis" :commonLineAndBarYAxis="energyConsumptionYAxis" :series="energyConsumptionSeriesData" />
                </div>
              </div>
            </div>
            <div class="portrait-of-enterprises-item">
              <dv-charts :option="energyConsumptionOption" />
            </div>
          </div>
        </transition>

        <!-- 设备监控 -->
        <transition name="el-zoom-in-center" >
          <div class="portrait-of-enterprises-right-strip" v-show="currentNav === '5'">
            <div class="portrait-of-enterprises-item2">
              <div class="portrait-of-enterprises-item-title">
                <span class="portrait-of-enterprises-item-title-info">设备运行情况</span>
              </div>
              <div class="device-operation-statistics-line">
                <div class="device-operation-statistics-line-left">
                  <div class="device-operation-statistics-line-info">{{ totalNumber }}</div>
                  <div class="device-operation-statistics-line-tip">设备总数</div>
                </div>
                <div id="deviceOnlineRate"></div>
<!--                <el-progress type="circle" :percentage="90" color="#30C330"></el-progress>-->
                <div class="device-operation-statistics-line-right">
                  <div class="device-operation-statistics-line-info">{{ offLineNumber }}</div>
                  <div class="device-operation-statistics-line-tip">设备离线数</div>
                </div>
              </div>
              <div class="portrait-of-enterprises-right-strip-device-box">
                <dv-border-box-2 :color="['#F9C986', '#DC9533']" >
                  <div class="portrait-of-enterprises-right-strip-device-list" v-if="fireControlDeviceList.length > 0">
                    <div class="portrait-of-enterprises-right-strip-device-item" v-for="fireControlDevice in fireControlDeviceList">
                      <i :class="['iconfon', fireControlDevice.icon]" ></i>
                      <div class="portrait-of-enterprises-right-strip-device-item-info">
                        <div class="portrait-of-enterprises-right-strip-device-item-info-name">{{fireControlDevice.type}}</div>
                        <div class="portrait-of-enterprises-right-strip-device-item-info-number">
                          <div>数量：{{fireControlDevice.totalNumber}}</div>
                          <div>在线率：{{fireControlDevice.online}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="portrait-of-enterprises-right-strip-device-no-tip" v-else>暂无设备信息</div>
                </dv-border-box-2>
              </div>

              <div class="portrait-of-enterprises-item-title">
                <span class="portrait-of-enterprises-item-title-info">本月消防报警排行</span>
              </div>

              <div style="width:100%;height: 1.75rem;flex: 1;text-align: left;padding: 0.1rem 0 0 0;">
                <dv-capsule-chart :config="alarmRankingConfig" style="height:100%" />
                <!--<dv-charts :option="alarmRankingOption" style="height: 100%;"/>-->
              </div>
            </div>
          </div>
        </transition>

      </div>

      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" class="park-display-screen-svg-box-svg-main" preserveAspectRatio="xMinYMin meet">
        <defs>
          <linearGradient id="orange_red" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#B3F2FDaa"/>
            <stop offset="100%" stop-color="#00A0E6aa"/>
          </linearGradient>
        </defs>
        <g>
<!--          <path class="leaflet-interactive" stroke="#00ff00" stroke-opacity="0.5" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" fill="url(#orange_red)" fill-rule="evenodd" d="M810 140 L810 170 L805 170 L805 190 L802 190 L802 490 L954 418 L1050 456 L1120 436 L1120 400 L1028 360z"></path>-->
        </g>
      </svg>
      <div class="park-display-screen-svg-box-svg-main" v-if="yqCode === 'jxgj'">
        <!-- 烟感点位 -->
        <div class="point-item" v-for="device in smokePointsList" :style="{color: '#00A0E6', position: 'absolute', left: device.x, top: device.y}">
          <div @click="smokePointClick(device)" style="position: relative;">
            <i class="iconfont el-icon-damai-dingweiweizhi" :style="{color: device.state === '0' ? '#aaaaaa' : (device.alarm === '1' ? '#FF4E4E' : '#32CC32')}"></i>
            <i class="iconfont el-icon-damai-yangan1" style="position: absolute;left: 10px;top: 8px;color: #ffffff;font-size: 18px;"></i>
            <div class="pulse" v-if="device.alarm === '1'"></div>
            <div class="pulse-big" v-if="device.alarm === '1'"></div>
          </div>
          <div class="video-tip-item" v-show="device.showTip">
            <div class="video-tip-item-close-line">
              <i class="iconfont el-icon-damai-close-o" @click="closeShow(device)"></i>
            </div>
            <div class="video-tip-item-iframe">
              <iframe
                v-if="hkVideoPlayerLink_smoke"
                :src="hkVideoPlayerLink_smoke"
                width="100%"
                height="100%"
                id="smokeOpenDevice"
                allowfullscreen>
              </iframe>
            </div>
            <div class="video-tip-item-bottom">
              <div v-if="device.alarm === '1'">
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmType}} <el-tag size="small" type="danger" effect="dark">紧急</el-tag></div>
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmTime}}</div>
                </div>
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">报警位置：{{device.alarmInfo.alarmLocation}}</div>
                </div>
              </div>
              <div class="video-tip-item-bottom-no-tip" v-else>暂无报警信息</div>
            </div>
          </div>
        </div>

        <!-- 温感点位 -->
        <div class="point-item" v-for="device in temperaturePointsList" :style="{color: '#00A0E6', position: 'absolute', left: device.x, top: device.y}">
          <div @click="temperaturePointClick(device)" style="position: relative;">
            <i class="iconfont el-icon-damai-dingweiweizhi" :style="{color: device.state === '0' ? '#aaaaaa' : (device.alarm === '1' ? '#FF4E4E' : '#32CC32')}"></i>
            <i class="iconfont el-icon-damai-wengan" style="position: absolute;left: 10px;top: 9px;color: #ffffff;font-size: 18px;"></i>
            <div class="pulse" v-if="device.alarm === '1'"></div>
            <div class="pulse-big" v-if="device.alarm === '1'"></div>
          </div>
          <div class="video-tip-item" v-show="device.showTip">
            <div class="video-tip-item-close-line">
              <i class="iconfont el-icon-damai-close-o" @click="temperatureCloseShow(device)"></i>
            </div>
            <div class="video-tip-item-iframe">
              <iframe
                v-if="hkVideoPlayerLink_temperature"
                :src="hkVideoPlayerLink_temperature"
                width="100%"
                height="100%"
                id="temperatureOpenDevice"
                allowfullscreen>
              </iframe>
            </div>
            <div class="video-tip-item-bottom">
              <div v-if="device.alarm === '1'">
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmType}} <el-tag size="small" type="danger" effect="dark">紧急</el-tag></div>
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmTime}}</div>
                </div>
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">报警位置：{{device.alarmInfo.alarmLocation}}</div>
                </div>
              </div>
              <div class="video-tip-item-bottom-no-tip" v-else>暂无报警信息</div>
            </div>
          </div>
        </div>

        <!-- 液位点位 -->
        <div class="point-item" v-for="(device, deviceIndex) in levelPointsList" :style="{color: '#00A0E6', position: 'absolute', left: device.x, top: device.y}">
          <div @click="levelPointClick(device)" style="position: relative;" :title="device.deviceName">
            <i class="iconfont el-icon-damai-dingweiweizhi" :style="{color: device.state === '0' ? '#aaaaaa' : (device.alarm === '1' ? '#FF4E4E' : '#32CC32')}"></i>
            <i class="iconfont el-icon-damai-yeweitance" style="position: absolute;left: 10px;top: 9px;color: #ffffff;font-size: 18px;"></i>
            <div class="pulse" v-if="device.alarm === '1'"></div>
            <div class="pulse-big" v-if="device.alarm === '1'"></div>
          </div>
          <div class="video-tip-item" v-if="device.showTip">
            <div class="video-tip-item-close-line">
              <i class="iconfont el-icon-damai-close-o" @click="levelCloseShow(device)"></i>
            </div>
            <div class="video-tip-item-iframe">
              <common-meter :meterId="`levelMeter${deviceIndex}`" :series="device.chartOption" width="200px" height="200px" />
            </div>
            <div class="video-tip-item-bottom">
              <div v-if="device.alarm === '1'">
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmType}}
                    <el-tag size="small" type="danger" effect="dark">紧急</el-tag>
                  </div>
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmTime}}</div>
                </div>
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">报警位置：{{device.alarmInfo.alarmLocation}}</div>
                </div>
              </div>
              <div class="video-tip-item-bottom-no-tip" v-else>暂无报警信息</div>
            </div>
          </div>
        </div>

        <!-- 液压点位 -->
        <div class="point-item" v-for="(device, deviceIndex) in hydraulicPointsList" :style="{color: '#00A0E6', position: 'absolute', left: device.x, top: device.y}">
          <div @click="hydraulicPointClick(device)" style="position: relative;">
            <i class="iconfont el-icon-damai-dingweiweizhi" :style="{color: device.state === '0' ? '#aaaaaa' : (device.alarm === '1' ? '#FF4E4E' : '#32CC32')}"></i>
            <i class="iconfont el-icon-damai-xiaofangyeya" style="position: absolute;left: 10px;top: 9px;color: #ffffff;font-size: 18px;"></i>
            <div class="pulse" v-if="device.alarm === '1'"></div>
            <div class="pulse-big" v-if="device.alarm === '1'"></div>
          </div>
          <div class="video-tip-item" v-if="device.showTip">
            <div class="video-tip-item-close-line">
              <i class="iconfont el-icon-damai-close-o" @click="hydraulicCloseShow(device)"></i>
            </div>
            <div class="video-tip-item-iframe">
              <common-meter :meterId="`hydraulicMeter${deviceIndex}`" :series="device.chartOption" width="200px" height="200px" />
            </div>
            <div class="video-tip-item-bottom">
              <div v-if="device.alarm === '1'">
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmType}}
                    <el-tag size="small" type="danger" effect="dark">紧急</el-tag>
                  </div>
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmTime}}</div>
                </div>
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">报警位置：{{device.alarmInfo.alarmLocation}}</div>
                </div>
              </div>
              <div class="video-tip-item-bottom-no-tip" v-else>暂无报警信息</div>
            </div>
          </div>
        </div>

        <!-- 手报点位 -->
        <div class="point-item" v-for="device in handPointsList" :style="{color: '#00A0E6', position: 'absolute', left: device.x, top: device.y}">
          <div @click="handPointClick(device)" style="position: relative;">
            <i class="iconfont el-icon-damai-dingweiweizhi" :style="{color: device.state === '0' ? '#aaaaaa' : (device.alarm === '1' ? '#FF4E4E' : '#32CC32')}"></i>
            <i class="iconfont el-icon-damai-shou" style="position: absolute;left: 10px;top: 8px;color: #ffffff;font-size: 18px;"></i>
            <div class="pulse" v-if="device.alarm === '1'"></div>
            <div class="pulse-big" v-if="device.alarm === '1'"></div>
          </div>
          <div class="video-tip-item" v-show="device.showTip">
            <div class="video-tip-item-close-line">
              <i class="iconfont el-icon-damai-close-o" @click="handCloseShow(device)"></i>
            </div>
            <div class="video-tip-item-iframe">
              <iframe
                v-if="hkVideoPlayerLink_hand"
                :src="hkVideoPlayerLink_hand"
                width="100%"
                height="100%"
                id="handOpenDevice"
                allowfullscreen>
              </iframe>
            </div>
            <div class="video-tip-item-bottom">
              <div v-if="device.alarm === '1'">
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmType}} <el-tag size="small" type="danger" effect="dark">紧急</el-tag></div>
                  <div class="video-tip-item-bottom-line-info">{{device.alarmInfo.alarmTime}}</div>
                </div>
                <div class="video-tip-item-bottom-line">
                  <div class="video-tip-item-bottom-line-info">报警位置：{{device.alarmInfo.alarmLocation}}</div>
                </div>
              </div>
              <div class="video-tip-item-bottom-no-tip" v-else>暂无报警信息</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="park-display-screen-top">
      <div class="park-display-screen-top-enterprise-name">{{yqName}}</div>
    </div>



    <!-- 底 -->
    <!--<div class="park-display-screen-bottom"></div>-->
    <!--<div class="park-display-screen-bottom-basic-line">-->
      <!--<img :src="parkDisplayScreenBottomBasicBigMap" alt="" style="width: 3.2rem;height: 1.8rem">-->
      <!--<div style="display: flex;justify-content: space-between;flex-direction: column;height: 1.8rem;margin: 0 0.2rem 0 0.1rem;">-->
        <!--<img src="../../../assets/park_img.png" alt="" style="width: 1.2rem;height: 0.85rem;cursor: pointer;" @click="change3DMap(1)">-->
        <!--<img src="../../../assets/park_img2.jpg" alt="" style="width: 1.2rem;height: 0.85rem;cursor: pointer;" @click="change3DMap(2)">-->
      <!--</div>-->
      <!--<div class="park-display-screen-bottom-basic-line-item" v-for="basic in parkBasicInfo">-->
        <!--<img :src="basic.img" alt="" class="park-display-screen-bottom-basic-line-item-img">-->
        <!--<div class="park-display-screen-bottom-basic-line-item-info">-->
          <!--<div class="park-display-screen-bottom-basic-line-item-amount">{{basic.amount}}</div>-->
          <!--<div class="park-display-screen-bottom-basic-line-item-name">{{basic.name}}</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
  import SockJS from  'sockjs-client'
  import Stomp from 'stompjs'
  import Radar from '../../../components/Echarts/Radar/Radar'
  import CommonMultiline from '../../../components/Echarts/Multiline/CommonMultiline'
  import CommonLineAndBar from '../../../components/Echarts/Multiline/CommonLineAndBar'
  import BasicInfo from '../../../components/Basic/BasicInfo/basicInfo'
  import CustomizedPie from '../../../components/Echarts/Pie/Pie/CustomizedPie'
  import SceneModel from '../../../components/SceneModel/SceneModel'
  import CommonMeter from '../../../components/Echarts/Meter/commonMeter'
  import CommonRing from "../../../components/Echarts/Pie/Pie/commonRing";
  import {api} from "../../api/Alarm";
  import {bus} from "../../../utils/bus"
  import {errorHandler} from "../../../utils/errorHandler";

  let parkHonorTollingTimer = null

  export default {
    components: {
      CommonRing,
      CommonMeter,
      SceneModel,
      CustomizedPie,
      BasicInfo,
      CommonLineAndBar,
      CommonMultiline,
      Radar
    },
    name: 'park-display-screen',
    data () {
      return {
        yqName: '',
        yqCode: '',
        currentTime: '',
        currentNav: '5',
        leftNavList: [
          { name: '园区概况', code: '1', child: [{name: '用地面积', value: '12', unit: '亩'}, {name: '楼栋数量', value: '20', unit: '栋'}]},
          { name: '企业风采', code: '2', child: [{name: '入园企业', value: '12', unit: '家'}, {name: '软著专利', value: '20', unit: '份'}]},
          { name: '人才信息', code: '3', child: [{name: '从业人数', value: '12', unit: '人'}, {name: '专家团队', value: '20', unit: '支'}]},
          { name: '孵化成果', code: '4', child: [{name: '在孵企业', value: '12', unit: '家'}, {name: '毕业企业', value: '20', unit: '家'}]},
          { name: '设备监控', code: '5', child: [{name: '在线设备', value: '12', unit: '个'}, {name: '离线设备', value: '20', unit: '个'}]},
        ],
        parkDisplayScreenBottomBasicBigMap: require('../../../assets/park_img.png'),
        commonTitleStyle: {
          color: '#ffffff'
        },
        parkBasicInfo: [
          {name: '用地面积', amount: '111111', icon: '', img: require('../../../assets/basic/basic_area.png')},
          {name: '楼栋数量', amount: '222222', icon: '', img: require('../../../assets/basic/basic_investment.png')},
          {name: '从业人数', amount: '222222', icon: '', img: require('../../../assets/basic/basic_person.png')},
          {name: '建筑面积', amount: '33333', icon: '', img: require('../../../assets/basic/basic_housing.png')},
          {name: '已出租面积', amount: '99999', icon: '', img: require('../../../assets/basic/basic_chuzu.png')},
          {name: '已出售面积', amount: '33333', icon: '', img: require('../../../assets/basic/basic_chushou.png')},
        ],

        // 企业培育
        enterpriseDistributionConfig: {
          radius: '80%',
          activeRadius: '90%',
          data: [
            {
              name: '科技型中小微企业',
              value: 55
            },
            {
              name: '高新技术企业',
              value: 120
            },
            {
              name: '规模以上企业',
              value: 78
            },
            {
              name: '新增“小升规”企业',
              value: 66
            },
            {
              name: '隐形冠军企业数',
              value: 80
            },
            {
              name: '股改企业数',
              value: 80
            },
            {
              name: '上市(挂牌)企业数',
              value: 80
            }
          ],
          digitalFlopStyle: {
            fontSize: 12
          },
          lineWidth: 16
        },
        enterpriseDistributionInfoData: [
          {name: '入园企业', unit: '(家)', amount: '326', icon: 'el-icon-damai-company_quality'},
          {name: '从业人数', unit: '(人)', amount: '1600', icon: 'el-icon-damai-fangke1'},
          {name: '营业总收入', unit: '(万元)', amount: '888888', icon: 'el-icon-damai-chanzhi'},
          {name: '税收总额', unit: '(万元)', amount: '66666', icon: 'el-icon-damai-shuishou'},
        ],

        // 明星企业
        famousEnterpriseConfig: {
          header: ['企业名称', '入驻时间'],
          columnWidth: [200, 100],
          waitTime: 5000,
          headerBGC: '#26A4A7',
          data: [
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
            ['杭州大麦物联科技有限公司', '2017-09-19'],
          ]
        },

        // 园区荣誉
        parkHonorData: [
          {
            content: 'WIFI产业基地',
            timestamp: '2018-04-12 20:46',
            color: '#7AFDFE',
            size: 'large',
          }, {
            content: '市级孵化器',
            timestamp: '2018-04-03 20:46',
            color: '#7AFDFE',
            size: 'large',
          }, {
            content: '省级孵化器',
            timestamp: '2018-04-03 20:46',
            color: '#7AFDFE',
            size: 'large',
          }, {
            content: '国家级孵化器',
            timestamp: '2018-04-03 20:46',
            color: '#7AFDFE',
            size: 'large',
          }
        ],

        // 园区活跃度
        parkActivityConfig: {
          data: [
            {
              name: '员工',
              value: 167
            },
            {
              name: '访客',
              value: 123
            },
            {
              name: '三方人员',
              value: 98
            }
          ],
          // colors: ['#e062ae', '#fb7293', '#e690d1', '#32c5e9', '#96bfff'],
          unit: '人',
          showValue: true
        },

        // 园区发展
        parkDevelopmentConfig: {
          data: [
            {
              name: '人才数',
              value: 55
            },
            {
              name: '园区产值',
              value: 120
            },
            {
              name: '专利',
              value: 71
            },
            {
              name: '软著',
              value: 66
            },
            {
              name: '吸引资金',
              value: 80
            }
          ],
          img: [
            require('../../../assets/upper/rencai.png'),
            require('../../../assets/upper/chanzhi.png'),
            require('../../../assets/upper/zhuanli.png'),
            require('../../../assets/upper/ruanzhu.png'),
            require('../../../assets/upper/zijin.png'),
          ],
          showValue: true
        },

        parkInfo: {},

        // 人才分布
        enterpriseQualityRadarColor: ['#67E0E3'],
        enterpriseQualityRadarLegendData: {
          left: 0,
          top: 'middle',
          orient: 'vertical',
          textStyle: {
            color:'#ffffff',
          },
          show: false,
          data: ['']
        },
        enterpriseQualityRadarAxisData: [
          {
            name: {
              textStyle: {
                color: '#ffffff',
              },
            },
            indicator: [
              {text: '博士及以上', max: 100},
              {text: '硕士', max: 100},
              {text: '本科', max: 100},
              {text: '专科', max: 100},
              {text: '高中及以下', max: 100},
            ],
            radius: 60,
            center: ['50%', '50%'],
          },
        ],
        enterpriseQualityRadarSeriesData: [
          {
            type: 'radar',
            data: [
              {
                value: [85, 90, 90, 95, 95, ],
                name: '2018'
              },
            ]
          },
        ],

        // 学历分布
        educationMultilineColor: ['#67E0E3'],
        educationMultilineLegendData: {
          textStyle: {
            color: '#FFFFFF',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          data: ['博士', '硕士', '本科', '大专', '高中及以下']
        },
        educationMultilineXAxis: [
          {
            type: 'category',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
            boundaryGap: false,
            data: ['2018年', '2019年', '2020年']
          }
        ],
        educationMultilineSeriesData: [
          {
            name: '人才分布',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [
              {value: 335, name: '博士及以上'},
              {value: 310, name: '硕士'},
              {value: 274, name: '本科'},
              {value: 235, name: '专科'},
              {value: 400, name: '高中及以下'}
            ].sort(function (a, b) { return a.value - b.value; }),
            roseType: 'radius',
            label: {
              formatter: '{b}\n{c}({d}%)',
              color: 'rgba(255, 255, 255, 1)'
            },
            labelLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'
              },
              smooth: 0.2,
              length: 10,
              length2: 20
            },
            itemStyle: {
              color: '#439395',
              shadowBlur: 200,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },

            animationType: 'scale',
            animationEasing: 'elasticOut',
            animationDelay: function (idx) {
              return Math.random() * 200;
            }
          }
        ],

        // 知识产权
        intellectualPropertyMultilineColor: ['#67E0E3'],
        intellectualPropertyMultilineLegendData: {
          textStyle: {
            color: '#FFFFFF',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          show: false,
          data: ['发明专利', '实用新型', '外观专利', '软著', '其他']
        },
        intellectualPropertyMultilineAxis: [
          {
            name: {
              textStyle: {
                color: '#ffffff',
              },
            },
            indicator: [
              {text: '发明专利', max: 100},
              {text: '实用新型', max: 100},
              {text: '外观专利', max: 100},
              {text: '软著', max: 100},
              {text: '其他', max: 100},
            ],
            radius: 70,
            center: ['50%', '50%'],
          },
        ],
        intellectualPropertyMultilineSeriesData: [
          {
            type: 'radar',
            data: [
              {
                value: [85, 90, 90, 95, 95, ],
                name: '知识产权',
                label: {
                  show: true,
                  formatter: function(params) {
                    return params.value;
                  }
                },
              },
            ],
          },
        ],

        // 人员活跃度
        personnelActivityColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        personnelActivityLegendData: {
          textStyle: {
            color: '#FFFFFF',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          data: ['活跃员工数', '15天以上人数']
        },
        personnelActivityXAxis: [
          {
            type: 'category',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
            data: ['2018年', '2019年', '2020年']
          }
        ],
        personnelActivityYAxis: [
          {
            type: 'value',
            name: '',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
            minInterval: 1,
          }
        ],
        personnelActivitySeriesData: [
          {
            name: '活跃员工数',
            type: 'bar',
            data: [3, 5, 7]
          },
          {
            name: '15天以上人数',
            type: 'line',
            data: [1, 2, 4]
          }
        ],

        // 人员活跃度
        energyConsumptionColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        energyConsumptionLegendData: {
          textStyle: {
            color: '#FFFFFF',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          data: ['总产值', '亩均产值']
        },
        energyConsumptionXAxis: [
          {
            type: 'category',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
            data: ['2018年', '2019年', '2020年']
          }
        ],
        energyConsumptionYAxis: [
          {
            type: 'value',
            name: '',
            nameTextStyle: {
              color: '#ffffff',
            },
            axisLine:{
              lineStyle:{
                color:'#ffffff',
              }
            },
            splitLine: {
              show: false
            },
            minInterval: 1,
          }
        ],
        energyConsumptionSeriesData: [
          {
            name: '总产值',
            type: 'bar',
            data: [3, 5, 7]
          },
          {
            name: '亩均产值',
            type: 'line',
            data: [1, 2, 4]
          }
        ],

        // 设备总数
        totalNumber: '0',
        // 设备离线数
        offLineNumber: '0',
        // 消防设备类型
        fireControlDeviceList: [],

        // 设备在线率

        equipmentOnlineRateConfig: {
          value: 66,
          lineDash: [10, 2]
        },

        // 报警数
        totalAlarmNumber: '0',
        // 未消警数
        unDealNumber: '0',
        // 报警记录
        alarmRecordList: [],

        // 消防员列表
        firemanList: [],

        // 报警排名
        alarmRankingConfig: {},

        // 烟感点位信息
        smokePointsList: [
          {deviceName: 'A座4层楼梯烟感传感器', code: '08061', x: '964px', y: '459px', showTip: false, state: '1', alarm: '0'},
          {deviceName: 'A座4层四层烟感传感器', code: '08036', x: '454px', y: '279px', showTip: false, state: '1', alarm: '0'},
          {deviceName: 'A座4层四层烟感传感器', code: '08038', x: '964px', y: '299px', showTip: false, state: '1', alarm: '0'},
          {deviceName: 'A座4层四层烟感传感器', code: '08040', x: '654px', y: '329px', showTip: false, state: '1', alarm: '0'},
        ],
        // 温感点位信息
        temperaturePointsList: [
          {deviceName: 'a', code: 'a', x: '384px', y: '279px', showTip: false, state: '1', alarm: '0'},
          {deviceName: 'b', code: 'b', x: '1094px', y: '329px', showTip: false, state: '1', alarm: '0'},
          {deviceName: 'c', code: 'c', x: '1074px', y: '239px', showTip: false, state: '1', alarm: '0'},
        ],
        // 液位点位信息
        levelPointsList: [],
        // 液压点位信息
        hydraulicPointsList: [],
        // 手报点位信息
        handPointsList: [
          {deviceName: 'A座20层20F手动报警按钮', code: '08129', x: '1034px', y: '429px', showTip: false, state: '1', alarm: '0'},
        ],

        hkVideoPlayerLink_smoke: '',
        hkVideoPlayerLink_temperature: '',
        hkVideoPlayerLink_hand: '',
        energyConsumptionOption: {
          title: {
            text: '周销售额趋势',
            style: {
              fill: '#fff',
            }
          },
          legend: {
            data: [
              {
                name: '销售额',
                color: '#aeeff0'
              },
              {
                name: '人流量',
                color: '#f1829f'
              }
            ],
            textStyle: {
              fontFamily: 'Arial',
              fontSize: 13,
              fill: '#fff'
            }
          },
          xAxis: {
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            splitLine: {
              show: false
            },
            axisLine: {
              style: {
                stroke: '#ffffff',
              }
            },
            axisTick: {
              style: {
                stroke: '#ffffff',
              }
            },
            axisLabel: {
              style: {
                fill: '#fff',
              }
            },
          },
          yAxis: [
            {
              name: '销售额',
              data: 'value',
              splitLine: {
                show: false
              },
              axisTick: {
                style: {
                  stroke: '#ffffff',
                }
              },
              axisLine: {
                style: {
                  stroke: '#ffffff',
                }
              },
              axisLabel: {
                style: {
                  fill: '#fff',
                }
              },
            },
            {
              name: '人流量',
              data: 'value',
              position: 'right',
              splitLine: {
                show: false
              },
              axisLine: {
                style: {
                  stroke: '#ffffff',
                }
              },
              axisTick: {
                style: {
                  stroke: '#ffffff',
                }
              },
              axisLabel: {
                style: {
                  fill: '#fff',
                }
              },
            }
          ],
          series: [
            {
              name: '人流量',
              style: {
                fontSize: 10
              },
              data: [1000, 1200, 900, 1500, 900, 1200, 1000],
              type: 'line',
              smooth: true,
              lineArea: {
                show: true,
                gradient: ['rgba(251, 114, 147, 1)', 'rgba(251, 114, 147, 0)']
              },
              lineStyle: {
                stroke: 'rgba(251, 114, 147, 1)',
                lineDash: [3, 3]
              },
              linePoint: {
                style: {
                  stroke: 'rgba(251, 114, 147, 1)'
                }
              },
              yAxisIndex: 1
            },
            {
              name: '销售额',
              data: [1500, 1700, 1400, 2000, 1400, 1700, 1500],
              type: 'bar',
              gradient: {
                color: ['rgba(103, 224, 227, .6)', 'rgba(103, 224, 227, .1)']
              },
              barStyle: {
                stroke: 'rgba(103, 224, 227, 1)'
              }
            }
          ]
        }
      }
    },
    created () {
      this.yqCode = bus.global.yqCode
      this.yqName = bus.global.yqName
      this.getTime()
      this.getCurrentTime()
      this.getWaterDeviceList()
    },
    mounted () {
      this.initWebSocket()
      this.parkHonorTolling()
      this.getDeviceOnline()
      this.getMonthAlarmRankList()
      this.getOverViewAlarmHandleManList()
    },
    methods: {
      // 获取设备在线率
      getDeviceOnline () {
        this.$axios.get(api.getDeviceStatistics, {})
          .then(res => {
            let data = res.data.data
            let fireControlDeviceList = []
            let typeIconList = [
              {name: '温感传感器', icon: 'el-icon-damai-wengan'},
              {name: '烟感传感器', icon: 'el-icon-damai-yangan1'},
              {name: '手动报警按钮', icon: 'el-icon-damai-shou'},
              {name: '液压设备', icon: 'el-icon-damai-xiaofangyeya'},
              {name: '液位设备', icon: 'el-icon-damai-yeweitance'},
              {name: '消火栓按钮', icon: 'el-icon-damai-xiaofang'},
            ]
            let alarmDeviceDtos = data.alarmDeviceDtos || []
            alarmDeviceDtos.map(v => {
              typeIconList.map(type => {
                if (v.type === type.name) {
                  v.icon = type.icon
                  if (v.totalNumber !== 0) {
                    v.online = `${(parseInt(v.onLineNumber || 0) / parseInt(v.totalNumber)*100).toFixed(2)}%`
                  } else {
                    v.online = `0%`
                  }
                  fireControlDeviceList.push(v)
                }
              })
            })
            this.totalNumber = data.totalNumber
            this.offLineNumber = data.offLineNumber
            this.fireControlDeviceList = fireControlDeviceList

            let commonRingItems = this.$echarts.init(document.getElementById('deviceOnlineRate'))
            commonRingItems.setOption({
              title : {
                show: false,
              },
              tooltip : {
                trigger: 'item',
                // formatter (data) {
                //   return `${data.name}:${data.value}`
                // },
                formatter: `{b} : {c} ({d}%)`,
              },
              legend: {
                show: false,
              },
              series : [
                {
                  name: '',
                  type: 'pie',
                  radius: ['60%', '90%'],
                  color: [{
                    type: 'linear',
                    x: 1,
                    y: 0,
                    x2: 0,
                    y2: 0,
                    colorStops: [{
                      offset: 0,
                      color: '#1CD405' // 0% 处的颜色
                    }, {
                      offset: 0.5,
                      color: '#68FF56' // 0% 处的颜色
                    }, {
                      offset: 1,
                      color: '#B5FCAD' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }, '#aaaaaa'],
                  data: [
                    {name: '在线', value: data.onLineNumber },
                    {name: '离线', value: data.offLineNumber }
                  ],
                  label: {
                    normal: {
                      show: false,
                      //   formatter (data) {
                      //     return `${data.name}\n${data.value}`
                      //   },
                    },
                    emphasis: {
                      show: true,
                      textStyle: {
                        fontSize: '12',
                      }
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                  }
                }
              ]
            })
          })
          .catch(errorHandler('获取设备信息失败'))
      },
      // 获取报警信息
      getAlarmStatistics () {
        this.$axios.get(api.getAlarmStatistics, {})
          .then(res => {
            let data = res.data.data
            this.alarmRecordList = data.alarmOpenRecords || []
            let alarmDeviceArr = []
            this.alarmRecordList.map(v => {alarmDeviceArr.push(v.deviceCode)})
            this.totalAlarmNumber = data.totalAlarmNumber
            this.unDealNumber = data.unDealNumber
            this.alarmRecordList.map(alarm => {
              if (alarm.alarmType === '手动报警按钮') {
                this.handPointsList.map(point => {
                  if (alarmDeviceArr.indexOf(point.code) === -1) {
                    point.alarm = '0'
                    point.alarmInfo = {}
                  }
                  if (point.code === alarm.deviceCode && alarm.alarmStatus === '未处理') {
                    point.alarm = '1'
                    point.alarmInfo = alarm
                    point.alarmInfo.alarmLocation = alarm.deviceName
                  }
                })
              }
              if (alarm.alarmType === '烟感传感器') {
                this.smokePointsList.map(point => {
                  if (alarmDeviceArr.indexOf(point.code) === -1) {
                    point.alarm = '0'
                    point.alarmInfo = {}
                  }
                  if (point.code === alarm.deviceCode && alarm.alarmStatus === '未处理') {
                    point.alarm = '1'
                    point.alarmInfo = alarm
                    point.alarmInfo.alarmLocation = alarm.deviceName
                  }
                })
              }
              if (alarm.alarmType === '温感传感器') {
                this.temperaturePointsList.map(point => {
                  if (alarmDeviceArr.indexOf(point.code) === -1) {
                    point.alarm = '0'
                    point.alarmInfo = {}
                  }
                  if (point.code === alarm.deviceCode && alarm.alarmStatus === '未处理') {
                    point.alarm = '1'
                    point.alarmInfo = alarm
                    point.alarmInfo.alarmLocation = alarm.deviceName
                  }
                })
              }
              if (alarm.alarmType === '液位设备') {
                this.levelPointsList.map(point => {
                  if (alarmDeviceArr.indexOf(point.code) === -1) {
                    point.alarm = '0'
                    point.alarmInfo = {}
                  }
                  if (point.code === alarm.deviceCode && alarm.alarmStatus === '未处理') {
                    point.alarm = '1'
                    point.alarmInfo = alarm
                    point.alarmInfo.alarmLocation = alarm.deviceName
                  }
                })
              }
              if (alarm.alarmType === '液压设备') {
                this.hydraulicPointsList.map(point => {
                  if (alarmDeviceArr.indexOf(point.code) === -1) {
                    point.alarm = '0'
                    point.alarmInfo = {}
                  }
                  if (point.code === alarm.deviceCode && alarm.alarmStatus === '未处理') {
                    point.alarm = '1'
                    point.alarmInfo = alarm
                    point.alarmInfo.alarmLocation = alarm.deviceName
                  }
                })
              }
            })
          })
          .catch(errorHandler('获取报警信息失败'))
      },
      // 获取月报警排行
      getMonthAlarmRankList () {
        this.$axios.get(api.getMonthAlarmRankList, {})
          .then(res => {
            let data = res.data.data
            data.map(v => {
              v.name = v.deviceName
              v.value = v.alarmCount
            })
            let alarmRankingConfig = {
              data: data || [],
              colors: ['#fb1313', '#FB4E13', '#FB7F13', '#FBA813', '#FBD013'],
              showValue: true
            }
            this.alarmRankingConfig = alarmRankingConfig
          })
          .catch(errorHandler('获取月报警排行失败'))
      },
      // 获取接警人列表
      getOverViewAlarmHandleManList () {
        this.$axios.get(api.getOverViewAlarmHandleManList, {})
          .then(res => {
            let data = res.data.data
            this.firemanList = data || []
          })
          .catch(errorHandler('获取接警人列表失败'))
      },
      // 获取消防设备数据
      getWaterDeviceList () {
        // this.$axios.post(api.getPayItemDetailPage, reqData)
        //   .then(res => {})
        //   .catch(errorHandler('获取保证金信息失败'))
        let data = [
          {"id":31,"createTime":null,"updateTime":null,"yqAppCode":"yhjy","deviceCode":"825300001000116-1-2","deviceName":"液压","deviceType":"2","parentCode":"825300001000116","parentName":"液压网关","deviceManufacturerName":"大麦","deviceManufacturerCode":"大麦","deviceModelName":"DM-FC-Y001","deviceModelCode":"DM-FC-Y001","deviceStatus":"1","gatewayDeviceInterface":"1","maximumThreshold":1.5,"theCurrentValue":0.78,"minimumThreshold":0.5,"alarmStatus":"0","buildingName":"","buildingCode":"", x: '434px', y: '169px'},
          {"id":28,"createTime":null,"updateTime":null,"yqAppCode":"yhjy","deviceCode":"825300001000117-1-1","deviceName":"3号楼水池","deviceType":"1","parentCode":"825300001000117","parentName":"液位网关","deviceManufacturerName":"大麦","deviceManufacturerCode":"大麦","deviceModelName":"DM-FC-S001","deviceModelCode":"DM-FC-S001","deviceStatus":"0","gatewayDeviceInterface":"1","maximumThreshold":200.0,"theCurrentValue":0.0,"minimumThreshold":50.0,"alarmStatus":"1","buildingName":"","buildingCode":"", x: '882px', y: '139px'}
        ]
        let levelPointsList = []
        let hydraulicPointsList = []
        data.map((v, i) => {
          v.showTip = false
          v.state = '1'
          v.alarm = '0'
          let typeName = '', max = 1, splitNumber = 4, seriesData = [{value: 0, name: ''}]
          if (v.deviceType === '1') {
            seriesData = [{value: v.theCurrentValue || 0, name: 'mm', itemStyle:{color: '#0084FF'}}]
          } else if (v.deviceType === '2') {
            seriesData = [{value: v.theCurrentValue || 0, name: 'Pa', itemStyle:{color: '#0084FF'}}]
          }
          typeName = v.deviceName
          max = parseInt(v.maximumThreshold * 1.5)
          let subsection1 = parseFloat(v.minimumThreshold * 0.5 / max).toFixed(2)
          let subsection2 = parseFloat(v.minimumThreshold / max).toFixed(2)
          let subsection3 = parseFloat(v.maximumThreshold / max).toFixed(2)
          let subsection4 = parseFloat(v.maximumThreshold * 1.2 / max).toFixed(2)
          let backgroundColor = '#2BCB60'
          if (v.theCurrentValue < v.minimumThreshold * 0.5) {
            backgroundColor = '#E9322B'
          } else if (v.theCurrentValue < v.minimumThreshold && v.theCurrentValue >= v.minimumThreshold * 0.5) {
            backgroundColor = '#E0E92B'
          } else if (v.theCurrentValue < v.maximumThreshold && v.theCurrentValue >= v.minimumThreshold) {
            backgroundColor = '#2BCB60'
          } else if (v.theCurrentValue < v.maximumThreshold * 1.2 && v.theCurrentValue >= v.maximumThreshold) {
            backgroundColor = '#E0E92B'
          } else {
            backgroundColor = '#E9322B'
          }
          let series = [
            {
              name: typeName,
              type: 'gauge',
              min: 0,
              max: max,
              splitNumber: splitNumber,
              radius: '90%',
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[subsection1, '#E9322B'], [subsection2, '#E0E92B'], [subsection3, '#2BCB60'], [subsection4, '#E0E92B'], [1, '#E9322B']],
                  width: 2,
                  fontSize: 12,
                  shadowColor: '#fff', //默认透明
                  shadowBlur: 3
                }
              },
              axisTick: {            // 坐标轴小标记
                length: 10,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  width: 1,
                  color: 'auto',
                  shadowColor: '#fff', //默认透明
                  shadowBlur: 2
                }
              },
              splitLine: {           // 分隔线
                length: 12,         // 属性length控制线长
                lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                  width: 1,
                  color: '#fff',
                  shadowColor: '#fff', //默认透明
                  shadowBlur: 5
                }
              },
              pointer: {           // 分隔线
                shadowColor: '#fff', //默认透明
                length: "60%",          // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
                width: 3,
              },
              title: {
                textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                  fontWeight: 'bolder',
                  fontSize: 12,
                  fontStyle: 'italic',
                  color: '#fff',
                  shadowColor: '#fff', //默认透明
                  shadowBlur: 5
                }
              },
              detail: {
                show: true,
                offsetCenter: [0, '80%'],
                textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                  backgroundColor: backgroundColor,
                  fontWeight: 'bolder',
                  color: '#ffffff',
                  shadowBlur: 5,
                  fontSize: 13,
                  offsetCenter: [0, '90%'],
                  textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                    fontWeight: 'bolder',
                    color: '#fff'
                  }
                }
              },
              data: seriesData
            },
          ]
          v.chartOption = series
          if (v.deviceType === '2') {
            hydraulicPointsList.push(v)
          } else if (v.deviceType === '1') {
            levelPointsList.push(v)
          }
        })
        this.hydraulicPointsList = hydraulicPointsList
        this.levelPointsList = levelPointsList
        console.log(this.hydraulicPointsList)
        console.log(this.levelPointsList)

        this.getAlarmStatistics()
      },

      // 时间定时器
      getTime () {
        setInterval(() => {
          this.getCurrentTime()
        }, 1000)
      },
      // 获取当前时间
      getCurrentTime () {
        let currentDate = new Date()
        let YYYY = currentDate.getFullYear()
        let MM = (currentDate.getMonth() + 1) < 10 ? '0' + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1)
        let DD = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate()
        let hh = currentDate.getHours() < 10 ? '0' + currentDate.getHours() : currentDate.getHours()
        let mm = currentDate.getMinutes() < 10 ? '0' + currentDate.getMinutes() : currentDate.getMinutes()
        let ss = currentDate.getSeconds() < 10 ? '0' + currentDate.getSeconds() : currentDate.getSeconds()
        let ww = currentDate.getDay()
        let weekDay=['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
        this.currentTime = `${YYYY}年${MM}月${DD}日 ${hh}:${mm}:${ss}`
      },
      // 园区荣誉滚动条
      parkHonorTolling () {
        clearInterval(parkHonorTollingTimer)
        let ht = -1;
        let _self = this
        let hasTime = 0
        let hasLostTime = 0
        parkHonorTollingTimer = setInterval(function(){
          let parkHonorTimer = document.getElementById('parkHonorTimer')
          if(parkHonorTimer) {
            let height = parkHonorTimer.clientHeight
            if (hasTime === 100) {
              //获取当前滚动条高度
              let current = parkHonorTimer.scrollTop
              if(current === ht){
                if (hasLostTime === 100) {
                  ht = -1
                  parkHonorTimer.scrollTop = 0
                  hasTime = 0
                  hasLostTime = 0
                } else {
                  hasLostTime++
                }
              } else {
                ht = current
                parkHonorTimer.scrollTop = current + 1
              }
            } else {
              hasTime++
            }
          }
        }, 100);
      },

      // 切换导航
      changeNav (nav) {
        this.currentNav = nav.code
      },

      // 切换地图格式
      change3DMap (type) {
        if (type === 1) {
          this.parkDisplayScreenBottomBasicBigMap = require('../../../assets/park_img.png')
        } else {
          this.parkDisplayScreenBottomBasicBigMap = require('../../../assets/park_img2.jpg')
        }
      },

      // 点击烟感设备
      smokePointClick (data) {
        this.hkVideoPlayerLink_smoke = ''
        this.temperaturePointsList.map(v => {v.showTip = false})
        this.levelPointsList.map(v => {v.showTip = false})
        this.hydraulicPointsList.map(v => {v.showTip = false})
        this.handPointsList.map(v => {v.showTip = false})
        this.smokePointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = true
            let deviceCode = ''
            if (data.alarm === '1') {
              if (data.alarmInfo) {
                deviceCode = data.alarmInfo.videoDeviceCodes || 'E10399674'
              } else {
                deviceCode = 'E10399674'
              }
            } else {
              deviceCode = 'E10399674'
            }
            this.$nextTick(() => {
              this.$axios.post(`${api.preview}`, {deviceCode: deviceCode})
                .then(res => {
                  let data = res.data.data
                  let token = data
                  let channelNum = '1'
                  this.hkVideoPlayerLink_smoke = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${deviceCode || 'E10399674'}/${channelNum || '1'}.live&autoplay=1&accessToken=${token}`
                  console.log(this.smokePointsList)
                })
                .catch(errorHandler('预览失败'))
            })
          } else {
            v.showTip = false
          }
        })
      },

      // 关闭烟感弹窗
      closeShow (data) {
        this.smokePointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = false
          }
        })
      },

      // 点击温感设备
      temperaturePointClick (data) {
        this.hkVideoPlayerLink_temperature = ''
        this.smokePointsList.map(v => {v.showTip = false})
        this.levelPointsList.map(v => {v.showTip = false})
        this.hydraulicPointsList.map(v => {v.showTip = false})
        this.handPointsList.map(v => {v.showTip = false})
        this.temperaturePointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = true
            let deviceCode = ''
            if (data.alarm === '1') {
              if (data.alarmInfo) {
                deviceCode = data.alarmInfo.videoDeviceCodes || 'E10399674'
              } else {
                deviceCode = 'E10399674'
              }
            } else {
              deviceCode = 'E10399674'
            }
            this.$nextTick(() => {
              this.$axios.post(`${api.preview}`, {deviceCode: deviceCode})
                .then(res => {
                  let data = res.data.data
                  let token = data
                  let channelNum = '1'
                  this.hkVideoPlayerLink_temperature = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${deviceCode || 'E10399674'}/${channelNum || '1'}.live&autoplay=1&accessToken=${token}`
                })
                .catch(errorHandler('预览失败'))
            })
          } else {
            v.showTip = false
          }
        })
      },

      // 关闭温感弹窗
      temperatureCloseShow (data) {
        this.temperaturePointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = false
          }
        })
      },

      // 点击液位设备
      levelPointClick (data) {
        this.smokePointsList.map(v => {v.showTip = false})
        this.temperaturePointsList.map(v => {v.showTip = false})
        this.hydraulicPointsList.map(v => {v.showTip = false})
        this.handPointsList.map(v => {v.showTip = false})
        this.levelPointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = true
          } else {
            v.showTip = false
          }
        })
      },

      // 关闭液位
      levelCloseShow (data) {
        this.levelPointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = false
          }
        })
      },

      hydraulicPointClick (data) {
        this.smokePointsList.map(v => {v.showTip = false})
        this.temperaturePointsList.map(v => {v.showTip = false})
        this.levelPointsList.map(v => {v.showTip = false})
        this.handPointsList.map(v => {v.showTip = false})
        this.hydraulicPointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = true
          } else {
            v.showTip = false
          }
        })
      },
      hydraulicCloseShow (data) {
        this.hydraulicPointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = false
          }
        })
      },

      // 手动
      handPointClick (data) {
        this.hkVideoPlayerLink_hand = ''
        this.smokePointsList.map(v => {v.showTip = false})
        this.temperaturePointsList.map(v => {v.showTip = false})
        this.levelPointsList.map(v => {v.showTip = false})
        this.hydraulicPointsList.map(v => {v.showTip = false})
        this.handPointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = true
            let deviceCode = ''
            if (data.alarm === '1') {
              if (data.alarmInfo) {
                deviceCode = data.alarmInfo.videoDeviceCodes || 'E10399674'
              } else {
                deviceCode = 'E10399674'
              }
            } else {
              deviceCode = 'E10399674'
            }
            this.$nextTick(() => {
              this.$axios.post(`${api.preview}`, {deviceCode: deviceCode})
                .then(res => {
                  let data = res.data.data
                  let token = data
                  let channelNum = '1'
                  this.hkVideoPlayerLink_hand = `https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${deviceCode || 'E10399674'}/${channelNum || '1'}.live&autoplay=1&accessToken=${token}`
                })
                .catch(errorHandler('预览失败'))
            })
          } else {
            v.showTip = false
          }
        })
      },
      handCloseShow (data) {
        this.handPointsList.map(v => {
          if (v.code === data.code) {
            v.showTip = false
          }
        })
      },

      initWebSocket() {
        this.connection();
        let self = this;
        // 断开重连机制,尝试发送消息,捕获异常发生时重连
        this.timer = setInterval(() => {
          try {
            self.stompClient.send("test");
          } catch (err) {
            console.log("断线了: " + err);
            self.connection();
          }
        }, 5000);
      },
      // 建立长连接
      connection() {
        // 建立连接对象
        this.socket = new SockJS('https://yq.damaiiot.com/stomp');//连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
        // 获取STOMP子协议的客户端对象
        this.stompClient = Stomp.over(this.socket);
        this.stompClient.heartbeat.outgoing = 10000;
        this.stompClient.heartbeat.incoming = 10000;
        // 定义客户端的认证信息,按需求配置
        let headers = {
          login: 'admin',
          passcode: 'damai0919damaiiot***',
          // additional header
          'client-id': 'my-client-id'
        };
        // 向服务器发起websocket连接
        this.stompClient.connect(headers,(frame) => {
          // 入场监听队列
          let deviceStatusQueue = `/exchange/alarm_device_status_exchange/${bus.global.yqCode}`
          let alarmOpenRecordQueue = `/exchange/alarm_open_record_exchange/${bus.global.yqCode}`
          let alarmCloseRecordQueue = `/exchange/alarm_close_record_exchange/${bus.global.yqCode}`

          this.stompClient.subscribe(deviceStatusQueue, (msg) => {
            let data = JSON.parse(msg.body)
            console.log(data)
          })
          this.stompClient.subscribe(alarmOpenRecordQueue, (msg) => {
            let data = JSON.parse(msg.body)
            console.log(data)
            this.getAlarmStatistics()
            this.getMonthAlarmRankList()
          })
          this.stompClient.subscribe(alarmCloseRecordQueue, (msg) => {
            let data = JSON.parse(msg.body)
            console.log(data)
            this.getAlarmStatistics()
            this.getMonthAlarmRankList()
          })
          // let personRecordQueue = `/amq/queue/person_record_queue`

          // this.stompClient.send('/exchange/car_out_record', headers, JSON.stringify({sender: '666',chatType: '777'}))
        }, (err) => {
          // console.log(err)
          this.disconnect()
          this.connection()
        });

      },
      // 断开连接
      disconnect() {
        if (this.stompClient != null) {
          this.stompClient.disconnect();
          console.log("Disconnected");
        }
      },
    },

    beforeDestroy () {
      this.disconnect()
    },
  }
</script>

<style scoped lang="less">
  .park-display-screen {
    min-width: 1200px;
    min-height: 675px;
    width: 100%;
    height: 100%;
    flex: 1;
    color: #FFFFFF;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    position: relative;
    background: rgba(9, 23, 32, 1);
    .portrait-of-enterprises-bg-img-out-box {
      width: 100%;
      height: 100%;
      flex: 1;
      margin: 0 auto;
      position: relative;
      /*box-shadow: 0 0 10px 10px rgba(3, 37, 107, .7);*/
    }
    .portrait-of-enterprises-bg-img-out-box:after {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      box-shadow: 0 0 120px 100px rgba(9, 23, 32, 1) inset;
    }
    .portrait-of-enterprises-bg-img-box {
      width: 1280px;
      height: 756px;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: 0 auto;
      transform: translateY(-50%);
      .portrait-of-enterprises-bg-img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .portrait-of-enterprises-bg-img-box:after {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      box-shadow: 0 0 180px 180px rgba(9, 23, 32, 1) inset;
    }
    .park-display-screen-svg-box {
      min-width: 1580px;
      height: 756px;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: 0 auto;
      transform: translateY(-50%);
      z-index: 9999999;
      .park-display-screen-svg-box-svg-main {
        width: 1580px;
        height: 756px;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 99;
        transform: translateY(-50%);
      }
      path {
        opacity: 0;
        cursor: pointer;
      }
      path:hover {
        opacity: 0.8;
      }
      .point-item {
        z-index: 999;
        i {
          cursor: pointer;
        }
        .el-icon-damai-dingweiweizhi {
          position: absolute;
          top: 0;
          left: 0;
          font-size: 38px;
          color: #32CC32;
        }
        .video-tip-item {
          width: 350px;
          height: 300px;
          position: absolute;
          top: 0;
          left: 16px;
          padding: 5px 25px 10px;
          background: url("../../../assets/basic/top_frame.png") no-repeat;
          background-size: 100% 100%;
          z-index: 99999;
          .video-tip-item-close-line {
            display: flex;
            justify-content: flex-end;
            i {
              color: #eeeeee;
            }
          }
          .video-tip-item-iframe {
            width: 300px;
            height: 225px;
            border-radius: 5px;
            overflow: hidden;
          }
          .video-tip-item-bottom {
            flex: 1;
            margin-top: 10px;
            .video-tip-item-bottom-line {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .video-tip-item-bottom-line-info {
                color: #ffffff;
              }
            }
            .video-tip-item-bottom-no-tip {
              color: #aaaaaa;
            }
          }
        }

        .pulse,.pulse-big {
          position: absolute;
          left: -11px;
          top: -15px;
          width: 60px;
          height: 60px;
          /*EF2D02*/
          border: 2px solid #FF0000;
          background: rgba(255, 0, 0, 1);
          border-radius: 50%;
          z-index: 100;
          opacity: 0;
          cursor: pointer;
        }
        .pulse{
          background: rgba(255, 0, 0, 1)!important;
          -webkit-animation: warn 0.9s ease-out;
          -moz-animation: warn 0.9s ease-out;
          animation: warn 0.9s ease-out;
          -webkit-animation-iteration-count: infinite;
          -moz-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
          box-shadow: 1px 1px 30px #FF0000;
        }
        .pulse-big{
          background: rgba(255, 0, 0, 1)!important;
          -webkit-animation: warn1 0.9s ease-out;
          -moz-animation: warn1 0.9s ease-out;
          animation: warn1 0.9s ease-out;
          -webkit-animation-iteration-count: infinite;
          -moz-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
          box-shadow: 1px 1px 30px #FF0000;
        }
      }
    }
    /*background: url("../../../assets/corporatePortrait/portraitOfEnterprisesInTheParkBg.png") no-repeat;*/
    /*background-size: 100% 100%;*/
    .park-display-screen-top {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 100%;
      height: 15%;
      padding-top: 10px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      z-index: 1;
      background-image: linear-gradient(rgba(9, 23, 32, 1) , rgba(9, 23, 32, 0));
      .park-display-screen-top-enterprise-name {
        font-size: 28px;
        font-weight: 600;
      }
    }
    .park-display-screen-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      align-items: center;
      z-index: 1;
      background-image: linear-gradient(rgba(9, 23, 32, 0) , rgba(9, 23, 32, 1));
    }
    .park-display-screen-bottom-basic-line {
      position: absolute;
      bottom: 20px;
      left: 0;
      width: 77%;
      padding: 0 10px;
      height: 100px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-end;
      z-index: 20;
      .park-display-screen-bottom-basic-line-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 15px;
        .park-display-screen-bottom-basic-line-item-img {
          width: 50px;
          height: 50px;
        }
        .park-display-screen-bottom-basic-line-item-info {
          .park-display-screen-bottom-basic-line-item-amount {}
          .park-display-screen-bottom-basic-line-item-name {
            font-size: 10px;
            color: rgb(103, 224, 227);
          }
        }
      }
    }
    /*.portrait-of-enterprises-left {*/
      /*width: 5rem;*/
      /*height: 92%;*/
      /*display: flex;*/
      /*justify-content: space-between;*/
      /*flex-direction: column;*/
      /*overflow-y: hidden;*/
      /*position: absolute;*/
      /*left: 0;*/
      /*top: 8%;*/
      /*z-index: 10;*/
      /*background-image: linear-gradient(to left, rgba(9, 23, 32, 0) , rgba(9, 23, 32, 1));*/
      /*.portrait-of-enterprises-left-nav {*/
        /*text-align: left;*/
        /*padding-left: 0.2rem;*/
        /*.portrait-of-enterprises-left-nav-item {*/
          /*-webkit-transition: all 0.5s;*/
          /*-moz-transition: all 0.5s;*/
          /*transition: all 0.5s;*/
          /*transform: translateX(0);*/
        /*}*/
        /*.portrait-of-enterprises-left-nav-item2 {*/
          /*-webkit-transition: all 0.5s;*/
          /*-moz-transition: all 0.5s;*/
          /*transition: all 0.5s;*/
          /*transform: translateX(0.8rem);*/
        /*}*/
        /*.portrait-of-enterprises-left-nav-item, .portrait-of-enterprises-left-nav-item2 {*/
          /*width: 3rem;*/
          /*display: flex;*/
          /*justify-content: flex-start;*/
          /*flex-direction: column;*/
          /*margin-bottom: 0.6rem;*/
          /*.portrait-of-enterprises-left-nav-item-title-box {*/
            /*cursor: pointer;*/
            /*background: url("../../../assets/basic/nav_title_bg.png") no-repeat;*/
            /*background-size: 100% 100%;*/
            /*.portrait-of-enterprises-left-nav-item-title {*/
              /*height: 0.8rem;*/
              /*font-size: 0.28rem;*/
              /*display: flex;*/
              /*justify-content: flex-start;*/
              /*align-items: center;*/
              /*color: #ffffff;*/
              /*padding: 0 0.36rem;*/
              /*margin-right: 0.1rem;*/
              /*position: relative;*/
              /*z-index: 5;*/
            /*}*/
          /*}*/
          /*!*.portrait-of-enterprises-left-nav-item-title::after {*!*/
            /*!*content: '';*!*/
            /*!*position: absolute;*!*/
            /*!*left: 0;*!*/
            /*!*right: 0;*!*/
            /*!*bottom: 0;*!*/
            /*!*top: 0;*!*/
            /*!*border-radius: 0 5px 5px 0;*!*/
            /*!*z-index: -1;*!*/
            /*!*border: 1px solid #67E0E3;*!*/
            /*!*border-left: 0;*!*/
            /*!*!*background: #15ADAE;*!*!*/
            /*!*transform: skewX(-25deg);*!*/
          /*!*}*!*/
          /*!*.portrait-of-enterprises-left-nav-item-title:hover::after {*!*/
          /*!*background: #54F3F4;*!*/
          /*!*}*!*/
          /*.portrait-of-enterprises-left-nav-item-main {*/
            /*display: flex;*/
            /*justify-content: space-between;*/
            /*.portrait-of-enterprises-left-nav-item-main-item {*/
              /*width: 50%;*/
              /*cursor: pointer;*/
            /*}*/
          /*}*/
        /*}*/
      /*}*/
    /*}*/
    .portrait-of-enterprises-left {
      width: 28%;
      height: 92%;
      display: flex;
      justify-content: flex-start;
      position: absolute;
      left: 0;
      top: 8%;
      z-index: 10;
      background-image: linear-gradient(to left, rgba(9, 23, 32, 0) , rgba(9, 23, 32, 1));
      .portrait-of-enterprises-right-strip {
        width: 75%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
    }
    .portrait-of-enterprises-right {
      width: 28%;
      height: 92%;
      display: flex;
      justify-content: flex-end;
      position: absolute;
      right: 0;
      top: 8%;
      z-index: 10;
      background-image: linear-gradient(to right, rgba(9, 23, 32, 0) , rgba(9, 23, 32, 1));
      .portrait-of-enterprises-right-strip {
        width: 75%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
      }
    }

    .portrait-of-enterprises-item {
      width: 100%;
      height: 33%;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .portrait-of-enterprises-item-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-family: SThupo;
        .portrait-of-enterprises-item-title-info {
          padding: 0 0 5px 0;
          background: url("../../../assets/basic/title_bottom.png") no-repeat;
          background-position: bottom center;
        }
        .portrait-of-enterprises-item-title-icon {
          font-size: 28px;
        }
        .portrait-of-enterprises-item-title-info {
          font-size: 16px;
          margin-left: 5px;
        }
      }
    }
    .portrait-of-enterprises-item2 {
      width: 100%;
      height: 100%;
      padding: 10px 20px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      .portrait-of-enterprises-item-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-family: SimHei;
        .portrait-of-enterprises-item-title-info {
          padding: 0 0 10px 0;
          background: url("../../../assets/basic/title_bottom.png") no-repeat;
          background-position: bottom center;
        }
        .portrait-of-enterprises-item-title-icon {
          font-size: 28px;
        }
        .portrait-of-enterprises-item-title-info {
          font-size: 18px;
          margin-left: 5px;
        }
      }

      .device-operation-statistics-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0;
        #deviceOnlineRate {
          width: 108px;
          height: 108px;
        }
        .device-operation-statistics-line-item {
          width: 200px;
          height: 120px;
          padding: 10px;
          .device-operation-statistics-line-item-tip {
            text-align: left;
            line-height: 15px;
            font-size: 12px;
          }
          .device-operation-statistics-line-item-info {
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            text-align: left;
            line-height: 35px;
            .device-operation-statistics-line-item-number {
              font-size: 18px;
            }
            .device-operation-statistics-line-item-unit {
              font-size: 10px;
            }
          }
        }

        .device-operation-statistics-line-info {
          font-family: fantasy;
          font-size: 24px;
        }
        .device-operation-statistics-line-tip {
          font-size: 10px;
        }
        .device-operation-statistics-line-right {
          .device-operation-statistics-line-info {
            color: #FB140F;
          }
        }
      }

      .portrait-of-enterprises-right-strip-device-box {
        width: 100%;
        height: 280px;
        margin-bottom: 20px;
        .portrait-of-enterprises-right-strip-device-no-tip {
          height: 100%;
          padding: 10px 15px;
          text-align: center;
          color: #aaaaaa;
          font-size: 12px;
        }
        .portrait-of-enterprises-right-strip-device-list {
          height: 100%;
          padding: 10px 15px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          overflow-y: auto;
          .portrait-of-enterprises-right-strip-device-item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            i {
              width: 50px;
              height: 40px;
              line-height: 40px;
              margin: 0 20px 0 0;
              font-size: 24px;
            }
            .portrait-of-enterprises-right-strip-device-item-info {
              flex: 1;
              .portrait-of-enterprises-right-strip-device-item-info-name {
                font-size: 14px;
                text-align: left;
              }
              .portrait-of-enterprises-right-strip-device-item-info-number {
                font-size: 12px;
                color: #aaaaaa;
                display: flex;
                justify-content: space-between;
                align-items: center;
              }
            }
          }
        }
      }

      .device-operation-alar-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0;
        .device-operation-alar-line-item {
          width: 100%;
          height: 60px;
          padding: 10px;
          .device-operation-alar-line-item-info {
            font-family: fantasy;
            font-size: 24px;
          }
          .device-operation-alar-line-item-name {
            font-size: 10px;
          }
        }
      }

      .alarm-record-table {
        height: 100%;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        text-align: center;
        font-size: 12px;
        padding: 10px 5px;
        .alarm-record-table-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #aaaaaa;
          padding: 10px 0;
        }
        .alarm-record-table-main {
          flex: 1;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          overflow-y: auto;
          .alarm-record-table-main-line {
            margin: 10px 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .alarm-record-table-main-no-tip {
            padding: 10px 15px;
            color: #aaaaaa;
          }
        }
      }

      .fireman-box {
        width: 100%;
        flex: 1;
        padding: 10px;
        margin: 10px auto;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .fireman-box-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .el-icon-damai-xiaofangyuan {
            font-size: 36px;
            background-image:-webkit-linear-gradient(bottom,red,#ff5f60,#f0c41b);
            -webkit-background-clip:text;
            -webkit-text-fill-color:transparent;
          }
          .fireman-box-line-name {
            text-align: left;
            margin-left: 5px;
            flex: 1;
          }
          .fireman-box-line-phone {}
        }
      }
    }


    /deep/ .el-progress__text {
      color: #ffffff;
    }
    /deep/.el-timeline-item__wrapper {
      text-align: left;
    }
    /deep/.el-timeline-item__content {
      color: #ffffff;
    }
    /deep/.el-timeline-item__timestamp {
      color: #eeeeee;
    }
    /deep/.unit-label {
      display: none;
    }
    /deep/.unit-text {
      display: none;
    }
    /deep/.label-column>div:last-child {
      display: none;
    }

    #parkHonorTimer::-webkit-scrollbar {
      display: none;
      width:0px;
      height:0px;
    }
    #parkHonorTimer .-o-scrollbar {
      width:0px;
      height:0px;
    }
    #parkHonorTimer {
      -ms-scroll-chaining: chained;
      -ms-overflow-style: none;
      -ms-content-zooming: zoom;
      -ms-scroll-rails: none;
      -ms-content-zoom-limit-min: 100%;
      -ms-content-zoom-limit-max: 500%;
      -ms-scroll-snap-type: proximity;
      -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
      -ms-overflow-style: none;
    }

    ::-webkit-scrollbar {/*滚动条整体样式*/
      width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }

    ::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px #F9C986;
      background: #F9C986;
    }

    ::-webkit-scrollbar-track {/*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px #A26E26;
      border-radius: 5px;
      background: #A26E26;
    }
  }

  @keyframes warn {
    0% {
      -moz-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }
    100% {
      -moz-transform: scale(1);
      transform: scale(1);
      opacity: 0;
    }
  }

  @keyframes warn1 {
    0% {
      -o-transform: scale(0);
      transform: scale(0);
      opacity: 1;
    }
    100% {
      -o-transform: scale(0.6);
      transform: scale(0.6);
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/ParkDisplayScreen/ParkDisplayScreen.vue